module.exports = __webpack_public_path__ + "assets/53fd1458b37949b126c4bf4629a7df52.mp3";